import { stripAccents } from "@/helpers/functions/StringHelpers";

export const getPeriodicidades = () => [
  { value: "MENSAL", text: "Mensal", months: 1 },
  { value: "BIMESTRAL", text: "Bimestral", months: 2 },
  { value: "TRIMESTRAL", text: "Trimestral", months: 3 },
  { value: "SEMESTRAL", text: "Semestral", months: 6 },
  { value: "ANUAL", text: "Anual", months: 12 },
];

/**
 * @param {string} name
 */
export function getPeriodiciByName(name) {
  return getPeriodicidades().find((item) =>
    stripAccents(item.value).includes(stripAccents(name))
  );
}
